import { Card, CardContent, Skeleton } from '@repo/shadcn';

import { CustomSkelton } from '../../../ui/custom.skelton';

export default function SaleSkeleton() {
    return (
        <div className="flex min-h-screen">
            <div className="flex-1 space-y-4 p-4">
                {/* Sale Type Options */}
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                    {[1, 2, 3].map((i) => (
                        <Card className="p-4" key={i}>
                            <div className="flex items-center space-x-4">
                                <Skeleton className="h-6 w-6 rounded" />
                                <div className="space-y-2">
                                    <Skeleton className="h-5 w-24" />
                                    <Skeleton className="h-4 w-32" />
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>

                {/* Product Selection Form */}
                <Card>
                    <CardContent className="p-4">
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6">
                                <Skeleton className="h-10 w-full" />
                            </div>
                            <div className="col-span-4 md:col-span-2">
                                <Skeleton className="h-10 w-full" />
                            </div>
                            <div className="col-span-4 md:col-span-2">
                                <Skeleton className="h-10 w-full" />
                            </div>
                            <div className="col-span-4 md:col-span-2">
                                <Skeleton className="h-10 w-full" />
                            </div>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CustomSkelton type="table" count={8} />
                </Card>

                {/* Total Items */}
                <div className="flex items-center space-x-2">
                    <Skeleton className="h-5 w-24" />
                    <Skeleton className="h-5 w-8" />
                </div>

                {/* Empty Cart State */}
                <div className="flex flex-col items-center justify-center space-y-4 p-8">
                    <Skeleton className="h-20 w-20 rounded-full" />
                    <Skeleton className="h-6 w-48" />
                    <Skeleton className="h-4 w-64" />
                </div>

                {/* Cart Actions */}
                <div className="flex justify-end space-x-2">
                    <Skeleton className="h-10 w-32" />
                    <Skeleton className="h-10 w-32" />
                    <Skeleton className="h-10 w-32" />
                </div>
            </div>

            {/* Summary Panel */}
            <Card className="m-4 h-[calc(100vh-120px)] w-80 p-4">
                <div className="space-y-4">
                    <div className="flex items-center justify-between">
                        <Skeleton className="h-6 w-24" />
                        <Skeleton className="h-6 w-6" />
                    </div>

                    {/* Summary Items */}
                    {[1, 2, 3, 4].map((i) => (
                        <div
                            key={i}
                            className="flex items-center justify-between"
                        >
                            <Skeleton className="h-4 w-16" />
                            <Skeleton className="h-4 w-20" />
                        </div>
                    ))}

                    <div className="border-t pt-4">
                        <div className="space-y-2">
                            {[1, 2].map((i) => (
                                <div
                                    key={i}
                                    className="flex items-center justify-between"
                                >
                                    <Skeleton className="h-4 w-28" />
                                    <Skeleton className="h-4 w-24" />
                                </div>
                            ))}
                        </div>
                    </div>

                    <Skeleton className="h-[100px] w-full" />
                    <Skeleton className="h-10 w-full" />
                </div>
            </Card>
        </div>
    );
}
